
import { Injectable, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';


import { EventService } from '../internal/event-service';
//import { Absence, Sighting } from '../../models/models';
import { StorageService } from "../internal/storage-service"

import { SPOTTER_ENV } from '@spotter/tokens/env.token';
import { SpotterEnvironment } from '@spotter/environments/environment.template';
import { Profile, TokenUser } from '@spotter/models/profile';
import { SiteShorthand } from '@spotter/environments/sites';



export interface TokenResponse {
    user: Profile;
    token: string;
}


/** The auth service deals with logging in and registering users */
@Injectable({ providedIn: 'root' })
export class AuthService {

    // A promise persisted to check if an auth request has been requested
    private authorizePromise?: Promise<Profile>;

    tokenUser?: Profile;
    mobileToken?: string;


    returnUrlAfterLogin = "";

    // Auth events
    loginStatusChanged: EventEmitter<any> = new EventEmitter<any>();
    userLoaded: EventEmitter<any> = new EventEmitter<any>();
    userLoggedIn: EventEmitter<Profile> = new EventEmitter<Profile>;





    /** Attempt to load the user on construction */
    constructor(public http: HttpClient, private storage: StorageService, public router: Router, public events: EventService, @Inject(SPOTTER_ENV) private env: SpotterEnvironment) {
      //  if (environment.format == 'mobile')
       //     this.loadUserFromStorage(); // WE load in the app initialiser
      //  else if (environment.format == 'web')
     //       this.loadUserFromAPI();

      //  console.log(environment.format);

        this.events.fail401.subscribe(() => {
            this.clearStoredUser();
        });
        
    }

    private clearStoredUser()
    {
        this.storage.remove('token');
        this.storage.remove('profile');
        this.tokenUser = undefined;
        this.mobileToken = "";
    }

    /** Gets the XSRF token from the backend */
    // public getXSRFToken() {
    //     this.tokenUser = undefined;
    //     return this.http.get<any>("/api/auth/csrf-cookie");
    // }

    /** A http get request to the `me` endpoint
     *  Can be used to check a user is still authenticated, for example when the user uploads a photo
     *  TODO: This may no longer be needed now the auth has a remember me function
     */
    // public me(): Observable<Profile> {
    //     return this.http.get<Profile>("/api/auth/me");
    // }

    //TODO: Reimplement but from API
    public checkSessionStillActive(redirectUrl?: string): Promise<boolean> {
        return new Promise<boolean> ((resolve, reject) => {

            this.storage.get('token').then((token) => {

                // No token, so don't attempt to hit the endpoint
                if (token == null || token == undefined || token == "")
                {
                    resolve(false);
                    return;
                }
                
                // Attempt to load profile to check auth is still valid
                this.http.get<Profile>("/api/auth/me").subscribe({
                    next: (profile) => {
                        if (profile == null || profile == undefined)
                        {
                            this.tokenUser = undefined;
                            if (redirectUrl != undefined)
                                this.router.navigateByUrl(redirectUrl);
    
                            resolve(false);
                        }
                        else
                        {
                            this.tokenUser = profile;
                            this.storage.set('profile', profile);
                            this.events.profileChanged.emit(this.tokenUser);
                            resolve(true);
                        }
                    },
                    error: (err) => {
                        console.error(err);
                        reject(err);
                    }
                });
            })
            .catch(() => {
                console.warn("Unable to check storage for token");
                resolve(false);
            })

            
        });
       
    }

    /** Loads the user from the local storage
     *  This method is used to retrieve the user data in the app
     */
    public async loadUserFromStorage(): Promise<Profile> {
        
        // Get the saved mobile token from storage
        await this.storage.get("token").then((token) => {
            if (token)
            {
                this.mobileToken = token;
                this.events.tokenLoaded.emit(token);
            }
        });

        if (this.mobileToken)
        {
            await this.storage.get('profile').then((profile) => {
                this.tokenUser = profile;
            });
        }

        return this.storage.get("profile");
    }

    /** Loads the user from the API
     *  If a user is logged in, it will return their profile, otherwise it will be null
     */
    // public async loadUserFromAPI(): Promise<Profile> {
    //     if (!this.authorizePromise)
    //     {
    //         this.authorizePromise = new Promise((resolve, reject) => {
    //             this.http.get<Profile>("/api/auth/me")
    //                 .subscribe({
    //                     next: (user) => {
    //                         if (user)
    //                         {
    //                             this.tokenUser = user;
    //                             this.events.avatarChanged.emit(this.tokenUser);
    //                         }
    //                         resolve(user);
    //                     },
    //                     error: (error) => {
    //                         console.error("Error getting the logged in status from the database");
    //                         console.error(error);
    //                         reject(error);
    //                     }
    //                 });

    //         });
    //     }

    //     return this.authorizePromise;
    // }






    /** Saves the user's device ID in the API database/
     *  The token is stored so we don't ping the DB again if we already have.
     */
    public async registerNotificationToken(token: string, platform: string): Promise<string> {
        return new Promise<string> (async (resolve, reject) => {
            if (await this.storage.get("push_notification_token") == token)
            {
                resolve(token); 
                return; 
            } 

            this.http.post<string>("/api/auth/register-notification-token", {token: token, platform: platform}).subscribe({
                next: async (savedToken) => {
                    await this.storage.set('push_notification_token', savedToken);
                    resolve(savedToken);
                },
                error: (err) => {
                    console.error(err);
                    reject(err);
                }
            })
        });
    }

    /** Reloads the profile. You might want to call this after updating the avatar or similar. */
    public async reloadProfile(): Promise<Profile> {
        return new Promise<Profile> (async (resolve, reject) => {
            this.storage.get("token")
            .then((token) => {
                if (token)
                {
                    this.http.get<Profile>("/api/auth/me")
                    .subscribe({
                        next: (user) => {
                            if (user)
                            {
                                this.tokenUser = user;
                                this.storage.set('profile', user);
                                this.events.profileChanged.emit(this.tokenUser);
                                resolve(user);
                            }
                            reject();
                        },
                        error: (error) => {
                            console.error("Error getting the logged in status from the database");
                            console.error(error);
                            reject(error);
                        }
                    });
                }
                this.mobileToken = token;

            this.events.tokenLoaded.emit(token);
        });
    });
    }




    /** Reloads the user
     *  Attempts to reload the user stored in the service
     *  For mobile, this loads the token and profile from the Storage service
     *  For web, this creates a new auth promise if not there
     *  This can be used if you update the user's details or avatar for example
     *  // TODO: This can maybe be refactored
     */
    // public async reloadUser(): Promise<Profile> {
    //     console.log("Reloading user");
        
    //     // Get the saved mobile token from storage
    //     await this.storage.get("token").then((token) => {
    //         if (token)
    //             this.mobileToken = token;

    //         this.events.tokenLoaded.emit(token);
    //     });

    //     if (this.mobileToken)
    //         return this.storage.get("profile");




    //     if (!this.authorizePromise)
    //     {
    //         this.authorizePromise = new Promise((resolve, reject) => {
    //             this.http.get<Profile>("/api/auth/me")
    //                 .subscribe({
    //                     next: (user) => {
    //                         if (user)
    //                         {
    //                             this.tokenUser = user;
    //                             this.events.avatarChanged.emit(this.tokenUser);
    //                         }
    //                         resolve(user);
    //                     },
    //                     error: (error) => {
    //                         console.error("Error getting the logged in status from the database");
    //                         console.error(error);
    //                         reject(error);
    //                     }
    //                 });

    //         });
    //     }

    //     return this.authorizePromise;
    // }

    /** Checks if a user is currently logged in.
    *  You may optionally pass a path to navigate to if this fails */
    public isLoggedIn(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            if (this.tokenUser)
            {
                resolve(true);
                return;
            }

            resolve(false);

            // this.reloadUser().then((profile) => {
            //     if (this.tokenUser)
            //         resolve(true);
            //     else
            //         resolve(false);
            // });
        });
    }



    // TODO: Remove all promises and check username for matches but not undefined
    public isAdminSync(): boolean
    {
        if (!this.tokenUser)
            return false;

        return this.isProfileAdmin(this.tokenUser);
    }




    /** Checks is the user is logged in and has admin level rights */
    public isAdmin(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.isLoggedIn().then(() => {
                resolve((this.tokenUser && this.isProfileAdmin(this.tokenUser)) ? true : false)
            });
        });
    }

    /** Checks if a profile has admin access rights
     *  Useful if you are checking the current user after you know it has been loaded
     */
    public isProfileAdmin(profile: Profile): boolean {
        return profile.access_level >= 4;
    }



    public getAdminAccessLevel(): number {
        return 4;
    }


    /** Checks if a user is currently logged out */
    public isLoggedOut(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            if (!this.tokenUser)
            {
                resolve(true);
                return;
            }

            resolve(false);

            // this.reloadUser().then((profile) => {
            //     if (this.tokenUser)
            //         resolve(false);
            //     else
            //         resolve(true);
            // });

        });
    }



    public delete(username: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.http.post<string>("/api/auth/delete/" + username, {})
                .subscribe({
                    next: (result) => {
                        resolve();
                    },
                    error: (error) => {
                        reject();
                    }
                });
        });
    }

    public changePassword(password: string): Promise<TokenUser> {
        return new Promise((resolve, reject) => {
            this.http.post<TokenUser>("/api/auth/change-password", { password: password })
                .subscribe({
                    next: (tokenUser) => {
                        resolve(tokenUser);
                    },
                    error: (err) => {
                        reject(err.error);
                    }
                });
        });
    }

    /*  public isLoggedOut(redirectIfFails: string = ""): Observable<boolean>
         {
             return Observable.create(observer => {
                 if (this.tokenUser != undefined)
                 {
                     if (redirectIfFails != "")
                         this.authFailure.emit(redirectIfFails);
                     observer.next(false);
                     observer.complete();
                 }
     
                 this.storage.get('user').then(data => {
                     if (data)
                     {
                         if (redirectIfFails != "")
                             this.authFailure.emit(redirectIfFails);
                         observer.next(false);
                     }
                     else
                         observer.next(true);
                     observer.complete();
                 });
     
             });
         } */






    public getUserTypes(): Array<string> {
        return [
            "",
            "Research (academic)",
            "Research (commercial)",
            'Research (NGO)',
            'Research (Citizen scientist)',
            "Research (other)",
            'Nature enthusiast',
            'Photography',
            'Local resident',
            "Recreational diver/snorkeler",
            'Boat owner/operator',
            'Fishing/invertebrate collection',
            'Other'
        ];
    }


    public getAccessLevels(): Array<string> {
        return [
            "Spotter",
            "Super Spotter",
            "Scientist",
            "Moderator",
            "Admin",
            "Super Admin"
        ];
    }

     /** Gets a profile for a given username */
     public getBaseProfile(username: string): Observable<Profile> {
        return new Observable(observer => {
            this.http.get<Profile>("/api/user/profile/" + username)
                .subscribe({
                    next: (profile) => {
                        console.log(profile);
                        
                        observer.next(profile);
                        observer.complete();
                    },

                    // Error logging in the user
                    error: (error) => {
                        console.error("Unable to get the user");
                        observer.error("Unable to get the user");
                        observer.complete();
                    }
                });
        });
    }


    /** Gets a profile for a given username */
    public getProfile(username: string): Observable<Profile> {
        return new Observable(observer => {
            this.http.get<Profile>("/api/user/" + username)
                .subscribe({
                    next: (profile) => {
                        console.log(profile);
                        
                        observer.next(profile);
                        observer.complete();
                    },

                    // Error logging in the user
                    error: (error) => {
                        console.error("Unable to get the user");
                        observer.error("Unable to get the user");
                        observer.complete();
                    }
                });
        });
    }


    public isAdminOrHasUserId(userId: number)
    {
        if (!this.tokenUser)
            return false;

        return this.isProfileAdmin(this.tokenUser) || this.tokenUser.id == userId;
    }


    /** Registers a user and returns a long lived token for use in an app etc.
     *  Stores the returned token and user profile using the `StorageService`, loads the
     *  user into memory, and emits the relevant event
     * 
     *  @param  email       The user's email
     *  @param  username    A unique username for the user
     *  @param  password    A password for the user
     *  @param  name        The user's full name
     *  @param  device      A unique device name to accociate with the token
     *  @param  psNewsletter      A boolean to subscribe to the Project Seagrass newsletter
     *  @param  ssNewsletter      A boolean to subscribe to the Seagrass Spotter newsletter
     *  @returns            A Promise `TokenResponse` with the user's token and profile
     *  @see    register    Use the register function for a website registration
     */
    public async registerToken(email: string, username: string, password: string, name: string, device: string, psNewsletter = false, ssNewsletter = false): Promise<TokenResponse> {
        return new Promise((resolve, reject) => {
            this.http.post<TokenResponse>("/api/auth/register", { email: email, password: password, name: name, username: username, return_token: true, device: device, ss_newsletter: ssNewsletter, ps_newsletter: psNewsletter })
                .subscribe({
                    next: async (data: TokenResponse) => {
                        await this.storage.set("token", data.token);
                        await this.storage.set("profile", data.user);
                        await this.loadUserFromStorage();
                        resolve(data);
                    },
                    error: (error) => {
                        reject(error.error);
                    }
                });
        });
    }


    /** Requests a token from the API */
    public async requestToken(email: string, password: string, device: string): Promise<TokenResponse> {
        return new Promise((resolve, reject) => {
            this.http.post<TokenResponse>("/api/auth/token", { email: email, password: password, device: device })
                .subscribe({
                    next: async (data: TokenResponse) => {
                        await this.storage.set("token", data.token);
                        await this.storage.set("profile", data.user);
                        await this.loadUserFromStorage();
                        resolve(data);
                    },
                    error: (error) => {
                        console.warn(error);
                        reject(error.error);
                    }

                });
        });
    }



    /** Logs in a user
     * 	Returns an observable with the API result on success, or an error message on fail. */
    // public login(email: string, password: string): Observable<Profile> {
    //     return new Observable(observer => {
    //         this.http.post<Profile>("/api/auth/login", { email: email, password: password })
    //             .subscribe({
    //                 next: (data: Profile) => {
    //                     this.tokenUser = data;
    //                     this.userLoggedIn.emit(data);
    //                     this.events.avatarChanged.emit(data);
    //                     this.storage.set("profile", data);
    //                     observer.next(data);
    //                     observer.complete();
    //                 },
    //                 error: (error) => {
    //                     var alertText = "There was a problem logging in. Please try again later.";
    //                     if (error.status == 401)
    //                         alertText = error.error;
    //                     observer.error(alertText);
    //                     observer.complete();
    //                 }
    //             });
    //     });
    // }







    /** Registers a new user */
    // public register(email: string, username: string, password: string, name: string): Observable<Profile> {
    //     return new Observable(observer => {
    //         this.http.post<Profile>("/api/auth/register", { email: email, password: password, name: name, username: username })
    //             .subscribe({
    //                 next: (data) => {
    //                     this.tokenUser = data;
    //                     this.userLoggedIn.emit(data);
    //                     this.events.avatarChanged.emit(data);
    //                     observer.next(data);
    //                     observer.complete();
    //                 },
    //                 error: (error) => {
    //                     observer.error(error.error);
    //                     observer.complete();
    //                 }
    //             });
    //     });
    // }


    /** Logs the user out
     * 	Will return an observable bool of true when complete
     */
    // public logout(): Observable<Boolean> {
    //     return new Observable(observer => {
    //         this.http.post<TokenUser>("/api/auth/logout", {})
    //             .subscribe({
    //                 next: (data) => {
    //                     //this.userLoggedIn.emit(data);
    //                     this.tokenUser = undefined;
    //                     this.router.navigateByUrl("/");
    //                     observer.next(true);
    //                     observer.complete();
    //                 },
    //                 error: (error) => {
    //                     observer.error(error.error);
    //                     observer.complete();
    //                 }
    //             });
    //     });
    // }


    /** Logs the user out
 * 	Will return an observable bool of true when complete
 */
    public logoutToken(): Promise<Boolean> {
        return new Promise((resolve, reject) => {
            this.http.post<TokenUser>("/api/auth/logout-token", {})
                .subscribe({
                    next: (data) => {
                        this.clearStoredUser();
                        resolve(true);
                    },
                    error: (error) => {
                        reject(error.error);
                    }
                });
        });
    }








    /** Requests a password reset for a user's email
     *  Returns a string for both success and error with information to show the user */
    public forgot(email: string, site: SiteShorthand): Observable<any> {
        return new Observable(observer => {
            this.http.post<any>("/api/auth/forgot", { email, site })
                .subscribe({
                    next: (resp) => {
                        observer.next(resp);
                        observer.complete();
                    },
                    error: (err) => {
                        observer.error(err.error);
                        observer.complete();
                    }
                });
        });
    }


    public reset(email: string, password: string, reset_token: string): Observable<any> {
        return new Observable(observer => {
            this.http.post<TokenUser>("/api/auth/reset", { email: email, password: password, reset_token: reset_token })
                .subscribe({
                    next: (s) => {
                        observer.next(s);
                        observer.complete();
                    },
                    error: (err) => {
                        console.error(err);

                        observer.error(err.error);
                        observer.complete();
                    }
                });
        });
        /*       success => {
                   this.storeUserFromAPI(success);
                   observer.next(success);
                   observer.complete();
               },
               error => {
                   observer.error(error.error.message);
                   observer.complete();
               });
           }); */
    }

    /** Stores the user in local storage */
    /*    private storeUserFromAPI(token)
        {
            this.storage.set('user', token);
            this.tokenUser = token;
        }
    
        /** Returns the headers needed for a POST request */
    /*    public getPostHeaders(): object
        {
            if (!this.tokenUser)
            console.error("No token user!");
    
            var httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type':  'application/json',
                  'Authorization': "Bearer " + this.tokenUser.access_token
                })
            }
             return httpOptions;
        }
    
    
      //  api.spotter.test/delete-user/
    
        public deleteUser(username: string): Observable<any> {
            return Observable.create(observer => {
                this.http.post<string>(this.globals.getAPIURL() + "delete-user/"+username, {}, this.getPostHeaders())
                    .subscribe((data) => {
                        observer.next(data);
                        observer.complete();
                    },
    
                    // Error logging in the user
                    error => {
                        alert(error);
                        observer.error(error);
                        observer.complete();
                    });
            });
        }
    
        public deleteSelf(): Observable<any> {
            return Observable.create(observer => {
                this.http.post<string>(this.globals.getAPIURL() + "delete-self", {}, this.getPostHeaders())
                    .subscribe((data) => {
                        observer.next(data);
                        observer.complete();
                    },
    
                    // Error logging in the user
                    error => {
                        alert(error);
                        observer.error(error);
                        observer.complete();
                    });
            });
        }
    
    	
    
    
        /** Gets the currently logged in user.
         * 	This doesn't do any sort of checks, so could be a null user. Use after the login checks etc.
         */
    /*	public getUser(): TokenUser {
            return this.tokenUser;
        }
    
        /** Gets all the users
         * 	You must be admin to do this
         */
    /*   public getUsers(): Observable< Array<Profile> >
        {
            return Observable.create(observer => {
                this.http.get< Array<Profile> >(this.globals.getAPIURL() + "user", this.getPostHeaders())
                    .subscribe((data) => {
                        observer.next(data);
                        observer.complete();
                    },
    
                    // Error logging in the user
                    error => {
                        console.error("Unable to get the users");
                        observer.error("Couldn't get the users");
                        observer.complete();
                    });
            });
    
        }
    
    
        /** Gets the current user, either already loaded or from storage.
         * 	Use this when the app first loads to properly load the user.
         *  Will return an error if they've not yet logged in.
         */
    /*	public getOrLoadUser(): Observable<TokenUser> {
            return Observable.create(observer => {
                // Make sure the Storage is ready to use
                this.storage.ready().then(() => {
                    // If user is loaded, then return it
                    if (this.tokenUser !== undefined)
                    {
                        observer.next(this.tokenUser);
                        observer.complete();
                    }
                    // If not, then load it
                    else
                    {
                        this.storage.get('user').then(data => {
                            if (data) {
                                this.tokenUser = data;
                                this.userLoaded.emit();
                                observer.next(this.tokenUser);
                                observer.complete();
                                this.refresh().subscribe();
                            }
                            else
                            {
                                observer.error();
                                observer.complete();
                            }
    
                        });
                    }
    
                });
    
            });
        }
    
        /** Logs the user out
         * 	Will return an observable bool of true when complete
         */
    /*	public logout(): Observable<Boolean>
        {
            return Observable.create(observer => {
                this.storage.remove('user').then(data => {
                    this.loginStatusChanged.emit(data);
                    this.http.post<string>(this.globals.getAPIURL() + "logout", {}, this.getPostHeaders()).subscribe();this.tokenUser = undefined;
                    observer.next(true);
                    observer.complete();
                });
            });
        }
    
    /*	public refresh(): Observable<TokenUser> {
            return Observable.create(observer => {
                this.storage.ready().then(() => {
                    this.http.post<TokenUser>(this.globals.getAPIURL() + "refresh/", {}, this.getPostHeaders())
                    .subscribe(
                    success => {
                        this.storeUserFromAPI(success);
                    },
                    error => {
                        this.error.tokenError.emit(error);
                      //  error("Token refresh failed!");
                        observer.complete();
    
                    });
    
                });
    
            });
        }
    
    
    
    
    */



    //========================================================================================================================
    //========================================================================================================================
    //========================================================================================================================
    //========================================================================================================================


    /** Updates a user's profile
     *  @param  profile      A complete user profile
    */
    public sendEmail(username: string, contents: string): Observable<string> {
        return new Observable(observer => {
            this.http.post<any>("/api/admin/send-email/" + username, { emailContents: contents })
                .subscribe({
                    next: (success) => {
                        observer.next(success.message);
                        observer.complete();
                    },
                    error: (error) => {
                        var alertText = "There was a problem sending the email. Please try again later.";
                        observer.error(alertText);
                        observer.complete();
                    }
                });
        });
    }


}
